
import request from '@/plugin/axios'

/**
 * 授权总额度、已至卡券额度、剩余未制卡券额度
 * @param {*} data
 * @returns
 */
export function homeQuotaNumStatistics (data) {
  return request({
    url: '/api/main/homeQuotaNumStatistics',
    method: 'get',
    params: data
  })
}
/**
 * 总商户数、父商户数、子商户数
 */
export function homeBusinessNumStatistics (data) {
  return request({
    url: '/api/main/homeBusinessNumStatistics',
    method: 'get',
    params: data
  })
}
/**
 * 总发券量 、券派发领取量 、券核销量、 券过期未核销 、总发卡量 、卡派发领取量 、卡核销量 、卡过期未核销
 */
export function homeQuotaNumStatistic (data) {
  return request({
    url: '/api/main/homeQuotaNumStatistic',
    method: 'get',
    params: data
  })
}
/**
 * 各个子商户剩余额度
 */
export function statisticsParentOrgQuota (data) {
  return request({
    url: '/api/main/statisticsParentOrgQuota',
    method: 'get',
    params: data
  })
}
/**
 * 已核销额度
 */
export function alreadyWriteOffStatistics (data) {
  return request({
    url: '/api/main/alreadyWriteOffStatistics',
    method: 'get',
    params: data
  })
}
export function pieBillingMethod () {
  return request({
    url: '/api/main/pieBillingMethod',
    method: 'get'
  })
}
export function statisticsAdPositionNum () {
  return request({
    url: '/api/main/statisticsAdPositionNum',
    method: 'get'
  })
}
export function queryAdvertiserAndFlowMainNum () {
  return request({
    url: '/api/main/queryAdvertiserAndFlowMainNum',
    method: 'get'
  })
}
export function queryLaunchNumOfFlowMain () {
  return request({
    url: '/api/main/queryLaunchNumOfFlowMain',
    method: 'get'
  })
}

export function thirtyCouponStatisticsLine (data) {
  return request({
    url: '/api/main/thirtyCouponStatisticsLine',
    method: 'get',
    params: data
  })
}

export function thirtyCardStatisticsLine (data) {
  return request({
    url: '/api/main/thirtyCardStatisticsLine',
    method: 'get',
    params: data
  })
}
export function queryThirtyLaunchNumLine (data) {
  return request({
    url: '/api/main/queryThirtyLaunchNumLine',
    method: 'get',
    params: data
  })
}
